import React from "react";
import { Box } from "@mui/material";
import { ServiceReportSourceType } from "../models/ServiceReportsModel";
import { dt } from "../utils/dt";
import useTranslation from "../../../shared/hooks/useTranslation";

interface SourceTypeBadgeProps {
  sourceType?: ServiceReportSourceType;
  serviceRequestInternalNumber?: string;
}

const SourceTypeBadge: React.FC<SourceTypeBadgeProps> = ({
  sourceType,
  serviceRequestInternalNumber,
}) => {
  const { translate } = useTranslation("myMachinery");

  if (!sourceType || sourceType === ServiceReportSourceType.manual) return null;

  const tokens = dt.serviceReports.sourceType;
  const config = sourceType === ServiceReportSourceType.requestForService
    ? { ...tokens.rfs, label: translate("sourceType.rfs") }
    : { ...tokens.maintenance, label: translate("sourceType.maintenance") };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          fontFamily: dt.font,
          fontSize: "11px",
          fontWeight: 600,
          color: config.text,
          backgroundColor: config.bg,
          border: `1px solid ${config.border}`,
          padding: "3px 10px",
          borderRadius: "12px",
          whiteSpace: "nowrap",
        }}
      >
        {config.label}
      </Box>
      {serviceRequestInternalNumber && (
        <Box
          sx={{
            fontFamily: dt.fontMono,
            fontSize: "12px",
            color: dt.textMuted,
          }}
        >
          #{serviceRequestInternalNumber}
        </Box>
      )}
    </Box>
  );
};

export default SourceTypeBadge;
